<template>
    <div class="row mb-4">
        <!-- Filters bar -->
        <div class="col-12">
            <div class="d-flex justify-content-end align-items-start flex-wrap gap-2">
                <button
                    class="btn bgc-success text-white fw-500 rounder-8 size-16"
                    @click="openFilterModal"
                >
                    <img src="/icons/filter-recomendation.svg" alt="icono" class="me-2 icon-white icons" />
                    Filtrar
                </button>
            </div>
        </div>
        <!-- Options configs -->
        <div class="col-12">
            <div class="d-flex align-items-end border-bottom mb-3">
                <button
                    v-for="tab in visibleTabs"
                    :key="tab.component"
                    type="button"
                    class="btn-tab d-flex align-items-center px-3 pb-2"
                    :class="{ 'active': typeComponentSelected === tab.component }"
                    :disabled="isLoading && typeComponentSelected !== tab.component"
                    @click="selectTypeComponent(tab.component)"
                >
                    {{ resolveTabLabel(tab, authentication_user, activeServiceId) }}
                </button>
            </div>
        </div>
        <div 
            class="col-12 mt-3"
            :class="tableWrapperClass"
        >
            <component :is="typeComponentSelected" :active-service-id="activeServiceId" @refrest="refrest" @loaded="onChildLoaded"></component>
        </div>
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {  shouldShowAsRecommender } from '../../../../utils/servicesValidation.js'
import {
    getConfigsRecConfig,
    getVisibleTabs,
    resolveTabLabel,
} from '../../../../utils/configsRecConfig.js'
import ModalForm from "../../../../components/modal.vue";
import FilterConfigsRec from './FilterConfigsRec.vue';
import ConfigMargin from './Margin/index.vue';
import ConfigCompetitor from './Competitor/index.vue';
import ConfigStock from './Stock/index.vue';
import ConfigReposicion from './Reposicion/index.vue';
import ConfigPromociones from './Promociones/index.vue';
import ConfigObjective from './Objective/index.vue';
import ConfigVisibility from './Visibility/index.vue';
export default {
    name: "ConfigsRec",
    components: {
        ModalForm,
        FilterConfigsRec,
        ConfigMargin,
        ConfigCompetitor,
        ConfigStock,
        ConfigReposicion,
        ConfigPromociones,
        ConfigObjective,
        ConfigVisibility,
    },
    data() {
        return {
            typeComponentSelected: '',
            isLoading: false,
            propHead: {
                action: "",
                open: false,
                module: "configs-rec",
                text: "",
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
        };
    },
    computed: {
        ...mapGetters([
            "authentication_user",
            "activeDesk"
        ]),
        activeServiceId() {
            return this.$route.name === 'op-configs' ? 2 : 5;
        },
        configsRecConfig() {
            return getConfigsRecConfig(this.authentication_user);
        },
        visibleTabs() {
            return getVisibleTabs(this.configsRecConfig, this.authentication_user, this.$route.name);
        },
        tableWrapperClass() {
            return {
                'table-wrapper-fixed': true,
                'table-wrapper-expanded': !this.activeDesk,
                'table-wrapper-with-sidebar': this.activeDesk
            }
        },
    },
    created() {
        this.selectDefaultTab();
    },
    destroyed() {
        this.reset_filters();
    },
    methods: {
        ...mapActions(["executeCommit"]),
        ...mapMutations(['set_filters', 'reset_filters']),
        selectDefaultTab() {
            const firstTab = this.visibleTabs[0];
            if (firstTab) {
                this.typeComponentSelected = firstTab.component;
            }
        },
        selectTypeComponent(type) {
            if (this.isLoading) return;
            if (this.typeComponentSelected === type) return;
            this.isLoading = true;
            this.typeComponentSelected = type;
        },
        resolveTabLabel(tab) {
            return resolveTabLabel(tab, this.authentication_user, this.activeServiceId);
        },
        openFilterModal() {
            this.componentName = 'FilterConfigsRec';
            this.propForm.size = false;
            this.propHead = {
                action: "Filtros",
                open: true,
                module: "configs-rec",
                text: "",
                component: this.componentName,
            };
        },
        closeModal() {
            this.propHead = {
                action: "",
                open: false,
                module: "configs-rec",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
        },
        onChildLoaded() {
            this.isLoading = false;
        },
        /**
         * Verifica si debe mostrar como recomendador (para usar en template)
         */
        shouldShowAsRecommender(user = null) {
            return shouldShowAsRecommender(user || this.authentication_user, this.activeServiceId);
        }
    },
}
</script>

<style scoped>
.btn-tab {
    background: transparent;
    border: 0;
    border-bottom: 3px solid transparent;
    color: #8B8B8B;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.2s ease;
}

.btn-tab.active {
    border-bottom-color: #1AA179;
    color: #1AA179;
}

.btn-tab:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.bgc-success {
    background-color: #1AA179 !important;
}


.table-wrapper-fixed {
    overflow: hidden;
}

.table-wrapper-expanded {
    overflow: hidden;
    width: calc(100vw - 70px);
}

/* Tabla cuando el sidebar está visible (estado normal) */
.table-wrapper-with-sidebar {
    width: calc(100vw - 287px);
}
</style>
